import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import {
  Contents,
  Tab,
  Button,
  SeasonTab,
  Table,
  TableHeader,
  TableList,
  Empty
} from './styled';

const BasketballMatchRecordPlayerTable = ({ data }) => {
  const [list, setList] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState('home');

  useEffect(() => {
    setList(data[selectedTeam].additionalTeamData);
  }, [selectedTeam]);

  return (
    <Contents>
      <Tab>
        <Button
          className={clsx(selectedTeam === 'home' ? 'active' : '')}
          onClick={() => setSelectedTeam('home')}
        >
          {data.home.name}
        </Button>
        <Button
          className={clsx(selectedTeam === 'away' ? 'active' : '')}
          onClick={() => setSelectedTeam('away')}
        >
          {data.away.name}
        </Button>
      </Tab>

      <Table>
        <TableHeader>
          <div className={'player'}>선수명</div>
          <div className={'row'}>출장시간</div>
          <div className={'row'}>야투</div>
          <div className={'row'}>3점슛</div>
          <div className={'row'}>자유투</div>
          <div className={'row'}>총득점</div>
          <div className={'row'}>어시스트</div>
          <div className={'row'}>리바운드</div>
          <div className={'row'}>스틸</div>
          <div className={'row'}>블록슛</div>
          <div className={'row'}>턴오버</div>
          <div className={'row'}>개인반칙</div>
        </TableHeader>
        {list.length > 0 ? (
          list.map((item, idx) => {
            // assists: 55
            // assistsAverage: "2.4"
            // blockedShots: 9
            // blockedShotsAverage: "0.4"
            // fieldGoalsAttempted: 230
            // fieldGoalsMade: 108
            // fieldGoalsMadeAverage: "4.7"
            // fieldGoalsPercentage: "47.0"
            // freeThrowsAttempted: 47
            // freeThrowsMade: 37
            // freeThrowsMadeAverage: "1.6"
            // freeThrowsPercentage: "78.7"
            // gameCount: 23
            // player: {id: 5602, firstName: "김", lastName: "영환", displayName: "김영환", uniform: "7", position: "F"}
            // points: 298
            // pointsAverage: "13.0"
            // reboundsDefensive: 52
            // reboundsDefensiveAverage: "2.3"
            // reboundsOffensive: 28
            // reboundsOffensiveAverage: "1.2"
            // reboundsTotal: 80
            // reboundsTotalAverage: "3.5"
            // started: false
            // steals: 19
            // stealsAverage: "0.8"
            // technicalFouls: 0
            // technicalFoulsAverage: "0.0"
            // threePointFieldGoalsAttempted: 114
            // threePointFieldGoalsMade: 45
            // threePointFieldGoalsMadeAverage: "2.0"
            // threePointFieldGoalsPercentage: "39.5"
            // timesPlayed: "763:2"
            // timesPlayedAverage: "33:10"
            // turnovers: 31
            // turnoversAverage: "1.3"
            const {
              timesPlayedAverage,
              points,
              assists,
              reboundsTotal,
              steals,
              blockedShots,
              turnovers,
              technicalFouls,
              fieldGoalsMade,
              fieldGoalsAttempted,
              threePointFieldGoalsAttempted,
              threePointFieldGoalsMade,
              freeThrowsAttempted,
              freeThrowsMade
            } = item;

            return (
              <TableList key={item.player.id}>
                <div className={'player'}>{item.player.displayName}</div>
                <div className={'row'}>{timesPlayedAverage}</div>
                <div className={'row'}>
                  {fieldGoalsMade}/{fieldGoalsAttempted}
                </div>
                <div className={'row'}>
                  {threePointFieldGoalsMade}/{threePointFieldGoalsAttempted}
                </div>
                <div className={'row'}>
                  {freeThrowsMade}/{freeThrowsAttempted}
                </div>
                <div className={'row'}>{points}</div>
                <div className={'row'}>{assists}</div>
                <div className={'row'}>{reboundsTotal}</div>
                <div className={'row'}>{steals}</div>
                <div className={'row'}>{blockedShots}</div>
                <div className={'row'}>{turnovers}</div>
                <div className={'row'}>{technicalFouls}</div>
              </TableList>
            );
          })
        ) : (
          <Empty>
            <div>선수 정보가 없습니다.</div>
          </Empty>
        )}
      </Table>
    </Contents>
  );
};

export default BasketballMatchRecordPlayerTable;
